import { FORM_STEP_PHRASES } from '@/consts/phrases/registrationPhrases';
import { usePhrase } from '@/hooks/general/usePhrase';
import { Button, Stack } from '@mui/material';

interface PreviousNextButtonsProps {
    hidePrevious?: boolean;
    hideNext?: boolean;
    onPreviousClicked?: () => void;
    nextLabel?: number;
    prevLabel?: number;
    nextDisabled?: boolean;
    previousDisabled?: boolean;
}

export const PreviousNextButtons = (props: PreviousNextButtonsProps) => {
    const { t } = usePhrase();
    const isFullwidth = props.hidePrevious || props.hideNext;
    return (
        <Stack
            direction="row"
            spacing={3}
            sx={{
                width: '100%',
                justifyContent: 'flex-end',
            }}
        >
            {!props.hidePrevious && (
                <Button
                    onClick={props.onPreviousClicked}
                    size="large"
                    color="primary"
                    variant="text"
                    disabled={props.previousDisabled}
                    loading={props.previousDisabled}
                    sx={{ width: { xs: isFullwidth ? '100%' : '50%', sm: 'auto' } }}
                >
                    {t(props.prevLabel ?? FORM_STEP_PHRASES.PREVIOUS)}
                </Button>
            )}
            {!props.hideNext && (
                <Button
                    type="submit"
                    size="large"
                    color="primary"
                    variant="contained"
                    disabled={props.nextDisabled}
                    loading={props.nextDisabled}
                    sx={{ width: { xs: isFullwidth ? '100%' : '50%', sm: 'auto' } }}
                >
                    {t(props.nextLabel ?? FORM_STEP_PHRASES.NEXT)}
                </Button>
            )}
        </Stack>
    );
};
